// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2HTYM","dragIcon":"SortableItem_dragIcon__YXLMm","disabled":"SortableItem_disabled__3ZVU-"};